import { version } from '~/package.json'

export default defineAppConfig({
  appVersion: version,
  siteName: 'Die Leckorter',
  apiBaseUrl: 'https://develop-api.1tool.cloud/suite/api/',
  // (Falls neue API Url nicht funktioniert):
  // apiBaseUrl: 'https://my.1tool.com/suite/api/',
  apiBaseUrlV2: 'https://api.1tool.cloud/v2/',
  tenantId: 'c8513a05-9606-43da-8276-f79ba87cd556',
  routing: {
    startPage: 'dashboard'
  },
  vendor: {
    vuelidate: {
      $lazy: true,
      $autoDirty: false
    },
    marked: { headerIds: false, mangle: false }
  },
  optimizeDeps: {
    include: ['esm-dep' > 'cjs-dep']
  },
  ui: {
    primary: 'customPrimary'
  }
})
